import _Vue from 'vue';
import axios from 'axios';
export default {
  install(Vue: typeof _Vue) {
    Vue.prototype.$addPv = (activityId: number, classId: number = 9) => {
      if (process.env.NODE_ENV === 'production') {
        axios.get(
          `//www.cqcb.com/e/public/ViewClick/?classid=${classId}&id=${activityId}&addclick=1`,
        );
        axios.get(
          `//www.cqcb.com/e/public/onclick/?enews=donews&classid=${classId}&id=${activityId}`,
        );
      } else {
        console.log('添加pv成功: classId:' + classId + ',id:' + activityId);
      }
    };
  },
};
